// Patched copy of webpack/buildin/harmony-module.js for webpack 4.47.0.
//
// The upstream version does:
//   Object.defineProperty(module, "exports", { enumerable: true });
// which omits writable/configurable, defaulting both to false. Any
// subsequent `module.exports = ...` inside a webpack-bundled file then
// throws `TypeError: Cannot assign to read only property 'exports'`.
// This bites when babel-loader processes ES-module-flagged sources
// (e.g. @aspedia/* packages) and webpack injects the harmony-module
// polyfill into the IIFE wrapper. See https://github.com/webpack/webpack/issues/9994
//
// Wired via `resolve.alias` in config/webpack.config.common.js so we
// don't need to edit node_modules directly. Behaviour is otherwise
// identical to the upstream file.
module.exports = function(originalModule) {
	if (!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
			writable: true,
			configurable: true
		});
		module.webpackPolyfill = 1;
	}
	return module;
};
